import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ rating = 0, size = 14, className = "" }) => {
  const full = Math.round(rating);
  return (
    <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${rating} out of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= full ? "fill-accent text-accent" : "text-zinc-700"}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
};
